/**
 * Admin
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import {  HttpHeaders, HttpParams,
          HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateSpecialWagerTypeRaceCommand } from '../model/createSpecialWagerTypeRaceCommand';
import { SpecialWagerTypeRace } from '../model/specialWagerTypeRace';
import { SpecialWagerTypeRaceIndex } from '../model/specialWagerTypeRaceIndex';
import { UpdateSpecialWagerTypeRaceCommand } from '../model/updateSpecialWagerTypeRaceCommand';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


import { JtHttp, HttpResponse } from '../../JtHttp';

@Injectable()
export class SpecialWagerTypeRaceService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: JtHttp, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminVversionSpecialWagerTypeRacesGet(version: string, observe?: 'body', reportProgress?: boolean): Observable<SpecialWagerTypeRaceIndex>;
    public apiAdminVversionSpecialWagerTypeRacesGet(version: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SpecialWagerTypeRaceIndex>>;
    public apiAdminVversionSpecialWagerTypeRacesGet(version: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SpecialWagerTypeRaceIndex>>;
    public apiAdminVversionSpecialWagerTypeRacesGet(version: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling apiAdminVversionSpecialWagerTypeRacesGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SpecialWagerTypeRaceIndex>('get',`${this.basePath}/api/admin/v${encodeURIComponent(String(version))}/special-wager-type-races`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param version 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminVversionSpecialWagerTypeRacesIdPut(id: number, version: string, body?: UpdateSpecialWagerTypeRaceCommand, observe?: 'body', reportProgress?: boolean): Observable<SpecialWagerTypeRace>;
    public apiAdminVversionSpecialWagerTypeRacesIdPut(id: number, version: string, body?: UpdateSpecialWagerTypeRaceCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SpecialWagerTypeRace>>;
    public apiAdminVversionSpecialWagerTypeRacesIdPut(id: number, version: string, body?: UpdateSpecialWagerTypeRaceCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SpecialWagerTypeRace>>;
    public apiAdminVversionSpecialWagerTypeRacesIdPut(id: number, version: string, body?: UpdateSpecialWagerTypeRaceCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiAdminVversionSpecialWagerTypeRacesIdPut.');
        }

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling apiAdminVversionSpecialWagerTypeRacesIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SpecialWagerTypeRace>('put',`${this.basePath}/api/admin/v${encodeURIComponent(String(version))}/special-wager-type-races/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param version 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminVversionSpecialWagerTypeRacesPost(version: string, body?: CreateSpecialWagerTypeRaceCommand, observe?: 'body', reportProgress?: boolean): Observable<SpecialWagerTypeRace>;
    public apiAdminVversionSpecialWagerTypeRacesPost(version: string, body?: CreateSpecialWagerTypeRaceCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SpecialWagerTypeRace>>;
    public apiAdminVversionSpecialWagerTypeRacesPost(version: string, body?: CreateSpecialWagerTypeRaceCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SpecialWagerTypeRace>>;
    public apiAdminVversionSpecialWagerTypeRacesPost(version: string, body?: CreateSpecialWagerTypeRaceCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (version === null || version === undefined) {
            throw new Error('Required parameter version was null or undefined when calling apiAdminVversionSpecialWagerTypeRacesPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SpecialWagerTypeRace>('post',`${this.basePath}/api/admin/v${encodeURIComponent(String(version))}/special-wager-type-races`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
